'use strict';

const CONSTANTS = require('../constants/constants');

/**
 * Enable events
 */
var ENABLED_SRP_EVENTS = {
    NO_RESULTS: true,
    INTERACTION: true,
    EXIT: true,
    NO_INTERACTION_GENERAL: true,
    EXIT_OR_NO_INTERACTION_POSITIVE: true
};

var srpState = {
    viewItemListFired: false,
    selectItemFired: false,
    pendingSelectItem: false,
    internalNavigation: false,
    pushedLabels: {}
};

/**
 * @returns {boolean}
 */
function isSearchResultPage() {
    if (typeof window.dataLayer !== 'undefined'
        && window.dataLayer[0]
        && window.dataLayer[0].pageType === 'SearchResultPage') {
        return true;
    }

    var params = new URLSearchParams(window.location.search);
    return params.has('q') && $('.cc-plp.search-results').length > 0;
}

/**
 * @returns {boolean}
 */
function isNoResultsSearchPage() {
    return isSearchResultPage()
        && ($('#product-search-results .product').length === 0);
}

/**
 * @param {string} label
 */
function pushSearchResultPageEvent(label) {
    if (typeof dataLayer === 'undefined' || !label) {
        return;
    }

    if (srpState.pushedLabels[label]) {
        return;
    }

    srpState.pushedLabels[label] = true;

    dataLayer.push({
        event: CONSTANTS.GENERIC_EVENTS.EVENT_NAME,
        event_category: CONSTANTS.GENERIC_EVENTS.EVENT_CATEGORIES.SEARCH_RESULT_PAGE,
        event_label: label
    });

    // try {
    //     sessionStorage.removeItem('srpTestLog');
    //     var log = JSON.parse(sessionStorage.getItem('srpTestLog') || '[]');
    //     log.push({ label: label, at: new Date().toISOString() });
    //     sessionStorage.setItem('srpTestLog', JSON.stringify(log));
    // } catch (e) {}
}

/**
 * Punto 5 — Page SRP without results (page load).
 */
function attachNoResultsEvent() {
    if (!ENABLED_SRP_EVENTS.NO_RESULTS || !isNoResultsSearchPage()) {
        return;
    }

    pushSearchResultPageEvent(CONSTANTS.GENERIC_EVENTS.SEARCH_RESULT_PAGE_LABELS.NO_RESULTS);
}

/**
 * Called after push view_item_list on SRP.
 */
function onViewItemList() {
    if (!isSearchResultPage()) {
        return;
    }

    srpState.viewItemListFired = true;
}

/**
 * Called after push select_item on SRP.
 * Punto 1 — view_item_list + select_item.
 */
function onSelectItem() {
    if (!isSearchResultPage()) {
        return;
    }

    srpState.pendingSelectItem = false;
    srpState.selectItemFired = true;

    if (!ENABLED_SRP_EVENTS.INTERACTION || !srpState.viewItemListFired) {
        return;
    }

    pushSearchResultPageEvent(CONSTANTS.GENERIC_EVENTS.SEARCH_RESULT_PAGE_LABELS.INTERACTION);
}

/**
 * Mark click on product tile (select_item in progress).
 */
function onSelectItemPending() {
    if (!isSearchResultPage()) {
        return;
    }

    srpState.pendingSelectItem = true;
}

function clearSelectItemPending() {
    srpState.pendingSelectItem = false;
}

/**
 * Punto 2, 3, 4 — exit / navigation without select_item.
 */
function attachLeaveEvents() {
    if (!ENABLED_SRP_EVENTS.EXIT
        && !ENABLED_SRP_EVENTS.NO_INTERACTION_GENERAL
        && !ENABLED_SRP_EVENTS.EXIT_OR_NO_INTERACTION_POSITIVE) {
        return;
    }

    $(document).on('click.srpLeaveTracking', 'a[href]', function (e) {
        if (!isSearchResultPage() || srpState.selectItemFired || srpState.pendingSelectItem) {
            return;
        }

        if ($(e.currentTarget).closest('.js-tile, .product-tile, .cc-tile').length > 0) {
            return;
        }

        var href = $(this).attr('href');
        if (!href || href.indexOf('#') === 0 || href.indexOf('javascript:') === 0) {
            return;
        }

        try {
            var targetUrl = new URL(href, window.location.origin);
            if (targetUrl.origin === window.location.origin) {
                srpState.internalNavigation = true;
            }
        } catch (err) {
            // ignore invalid URLs
        }
    });

    window.addEventListener('pagehide', function () {
        if (!isSearchResultPage()
            || srpState.selectItemFired
            || srpState.pendingSelectItem) {
            return;
        }

        if (ENABLED_SRP_EVENTS.EXIT_OR_NO_INTERACTION_POSITIVE && srpState.viewItemListFired) {
            pushSearchResultPageEvent(
                CONSTANTS.GENERIC_EVENTS.SEARCH_RESULT_PAGE_LABELS.EXIT_OR_NO_INTERACTION_POSITIVE
            );
        }

        if (!srpState.internalNavigation && ENABLED_SRP_EVENTS.EXIT) {
            pushSearchResultPageEvent(CONSTANTS.GENERIC_EVENTS.SEARCH_RESULT_PAGE_LABELS.EXIT);
        }
    });

    if (ENABLED_SRP_EVENTS.NO_INTERACTION_GENERAL) {
        $(window).off('beforeunload.srpNoInteraction').on('beforeunload.srpNoInteraction', function () {
            if (!isSearchResultPage()
                || srpState.selectItemFired
                || srpState.pendingSelectItem
                || !srpState.internalNavigation) {
                return;
            }

            pushSearchResultPageEvent(
                CONSTANTS.GENERIC_EVENTS.SEARCH_RESULT_PAGE_LABELS.NO_INTERACTION_GENERAL
            );
        });
    }
}

/**
 * Register SRP listeners enabled in ENABLED_SRP_EVENTS.
 */
function attachSearchResultPageAnalytics() {
    if (!isSearchResultPage()) {
        return;
    }

    attachNoResultsEvent();
    attachLeaveEvents();
}

module.exports = {
    ENABLED_SRP_EVENTS: ENABLED_SRP_EVENTS,
    isSearchResultPage: isSearchResultPage,
    attachSearchResultPageAnalytics: attachSearchResultPageAnalytics,
    onViewItemList: onViewItemList,
    onSelectItem: onSelectItem,
    onSelectItemPending: onSelectItemPending,
    clearSelectItemPending: clearSelectItemPending
};
